/* eslint-disable
    no-shadow,
    one-var
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS101: Remove unnecessary use of Array.from
 * DS102: Remove unnecessary code created because of implicit returns
 * DS201: Simplify complex destructure assignments
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import React from 'react';
import _ from 'underscore';

import * as CRISPRUtil from 'molbio/crispr/CRISPRUtil';
import {TargetSite} from 'molbio/crispr/hr-template/HRTemplateStore';
import * as sequtil from 'molbio/SeqUtil';

const {isLeftPam} = CRISPRUtil;

function highlightMutant(
  // should be a StandardDNACodon, but we're slicing it out of bases at runtime so no guarantee
  original: string,
  // should be a StandardDNACodon, but we're slicing it out of bases at runtime so no guarantee
  mutated: string,
  index: number,
  targetSite: TargetSite,
  pam: string
): Array<JSX.Element> {
  const pamOnRight =
    (targetSite.strand === 1 && !isLeftPam(pam)) || (targetSite.strand === -1 && isLeftPam(pam));

  function inPAMSite(index: number): boolean {
    if (pamOnRight) {
      return sequtil.baseInRange(index, targetSite.end - pam.length, targetSite.end);
    } else {
      return sequtil.baseInRange(index, targetSite.start, targetSite.start + pam.length);
    }
  }

  const inTargetSite = (index: number): boolean =>
    sequtil.baseInRange(index, targetSite.start, targetSite.end);

  // eslint-disable-next-line no-restricted-syntax
  return _.map(_.zip(original, mutated), (...args) => {
    const [o, m] = Array.from(args[0]),
      j = args[1];
    return (
      <span
        key={`char-${o}-${m}-${j}`}
        className={
          !inTargetSite(index + j)
            ? 'text-muted'
            : o !== m
              ? 'text-danger'
              : inPAMSite(index + j)
                ? 'text-primary'
                : ''
        }
      >
        {m}
      </span>
    );
  });
}

export default highlightMutant;
